module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c69b1154248fcd2d2cdb8cde0421ef5a.png";